import {FETCH_HISTORY, FETCH_HISTORY_TABLE_DATA, FILE_DATA, FILE_DATA_UPLOAD, LOADER_STATUS, SAVE_TOTAL_PAGES, SAVE_TOTAL_PAGES_UPLOAD, UPLOAD_HISTORY, VIEW_TABLE_DATA } from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    fileDataUpload: [],
    uploadHistory:[],
    fetchHistory:[],
    viewTableData: [],
    fetchHistoryTableData: [],
    totalPages: 1,
    totalPagesUpload: 1,
};
  
  /* eslint-disable default-case, no-param-reassign */
  const gstr2xPrepareReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
            case FILE_DATA_UPLOAD:
            return {
              ...state,
              fileDataUpload:action.fileDataUpload
            }
            case FETCH_HISTORY:
              return {
                ...state,
                fetchHistory:action.Data
              }
              case UPLOAD_HISTORY:
              return {
                ...state,
                uploadHistory:action.Data
              }
              case VIEW_TABLE_DATA:
              return {
                ...state,
                viewTableData:action.data
              }
              case FETCH_HISTORY_TABLE_DATA:
              return {
                ...state,
                fetchHistoryTableData:action.fileData
                
              }
              case SAVE_TOTAL_PAGES:
                return {
                  ...state,
                  totalPages:action.pages
                }
                case SAVE_TOTAL_PAGES_UPLOAD:
                  return {
                    ...state,
                    totalPagesUpload:action.pages
                  }

        default:
        
          return state;
      }
    };
  
  export default gstr2xPrepareReducer;